import { render, staticRenderFns } from "./LittleDragons.vue?vue&type=template&id=be1f2726&scoped=true"
import script from "./LittleDragons.vue?vue&type=script&lang=js"
export * from "./LittleDragons.vue?vue&type=script&lang=js"
import style0 from "./LittleDragons.vue?vue&type=style&index=0&id=be1f2726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1f2726",
  null
  
)

export default component.exports